<template>
  <Pie :chartData="chartData" :styles="styles" :chartOptions="chartOptions" />
</template>
<script>
import { Pie } from 'vue-chartjs'
export default {
  props: {
    list: { type: Array, default: () => { return [] } },
    styles: {
      type: Object,
      default: () => {
        return {
          height: '200px'
        }
      }
    }
  },
  components: {
    Pie
  },
  data () {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'right'
          }
        }
      }
    }
  },
  computed: {
    chartData () {
      const labels = []
      const data = []
      this.list.map(c => {
        labels.push(c.name)
        data.push(c.total)
      })
      return {
        labels,
        datasets: [{
          label: '-',
          data,
          backgroundColor: [
            '#02adf1',
            'rgb(255, 205, 86)'
          ],
          hoverOffset: 4
        }]
      }
    }
  }
}
</script>
